var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightLeaf = function SvgRightLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71A20F",
    d: "M19.515 1.158c7.681 1.463-2.286 12.04-6.858 15.545l-2.744 2.286H1.227C.312 16.246 2.14 2.072 7.17 2.529c3.381.308 3.233 2.573 2.512 4.194 2.014-3.509 5.212-6.446 9.833-5.565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M7.17 13.502A23.3 23.3 0 0 1 9.23 7.56m3.427 9.144c4.572-3.505 14.54-14.082 6.858-15.545-4.984-.95-8.312 2.541-10.285 6.4m0 0c.99-1.523 1.964-4.663-2.06-5.029C2.141 2.072.312 16.246 1.227 18.99"
  })));
};
export default SvgRightLeaf;